        <div class="loader-container">
            <img class="loader-logo" src="./assets/logos/loader_V1.gif"/>
            
            <!-- <div style="width:100px;height:100px">
                <img src="./assets/tarangplus/danaglPlay_loader-02.gif"/>
            </div> -->
            <!-- <div style="width:100px;height:100px">
                <img src="./assets/tarangplus/DP_loader.3gp"/>
            </div> -->
        </div>
      

